import React from 'react';
import { Spinner } from 'reactstrap';


const Cargando = ({valor, visible}) => {
    let estilo = !visible && visible!==undefined ? 0 : 1; 
  return (
        <span>
            {valor ?
                (
                    <div className="bloque-cargando" style={{opacity:estilo}}>
                        <Spinner type="grow" color="primary" />
                    </div>
                ) : null
            }

        </span>

  );
};

export default Cargando;
